/*
  Frequently Bought Together — restore the widget to its placed position.

  WHY THIS EXISTS
  The app block you positioned in the theme editor renders an empty anchor,
  <div id="frequently-bought-together-app-block">, inside the buy box. As of
  2026-07-26 the app stopped rendering into that anchor and instead appends its
  widget to a `.page-width` fallback far below the description.

  This is NOT caused by the theme. Verified by measuring the original pre-audit
  theme (El Alba v1.0) at the same viewport: identical behaviour. What changed is
  the app itself — it switched from `bootstrap.min.js` (Script Tag) to
  `main.min.js` (app embed) the same day, and the new build ignores the anchor.

  This is a workaround, not a fix. The real fix is on the app side — check the
  placement setting in the Frequently Bought Together admin, or ask the vendor
  why the app block anchor is no longer honoured. Delete this file once that is
  resolved.
*/

(function () {
  const ANCHOR_ID = 'frequently-bought-together-app-block';
  const WIDGET_SELECTOR = '.cbb-frequently-bought-container';
  const WATCH_MS = 30000;

  function place() {
    const anchor = document.getElementById(ANCHOR_ID);
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (!anchor || !widget) return false;
    // Already where it belongs — do nothing, so we never fight ourselves.
    if (anchor.contains(widget)) return true;
    anchor.appendChild(widget);
    return true;
  }

  if (place()) return;

  // Debounce with setTimeout, NOT requestAnimationFrame: rAF is suspended in a
  // tab that is not being painted, so in a background tab the observer would
  // fire but its callback would never run and the widget would stay in the
  // wrong place until the tab was focused. Nothing here needs a frame.
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      place();
    }, 0);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // The app renders asynchronously; stop watching once that window has passed so
  // we are not observing the whole document for the life of the page.
  setTimeout(() => observer.disconnect(), WATCH_MS);

  // Dawn re-renders the buy box on variant change, which can make the app
  // re-inject. Re-check shortly after any variant interaction.
  document.addEventListener(
    'change',
    (event) => {
      if (!event.target.closest('variant-selects, variant-radios, .product-form__input')) return;
      setTimeout(place, 400);
      setTimeout(place, 1200);
    },
    { passive: true }
  );
})();
